import React, { useState, useEffect } from 'react';
import './Quiz.css';
import Questions from './Questions'

function Quiz(props) {

    const [questions, setQuestions] = useState([]);
    const [currentIndex, setCurrentIndex] = (useState(0));
    const [score, setScore] = useState(0);
    const [showAnswers, setShowAnswers] = useState(false);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [className, setClassName] = useState('btn-choice');
    const [showAnswerClassName, setShowAnswerClassName] = useState(true);
    const [correctAnswer, showCorrectAnswer] = useState(false);
    const [additionalInfo, setShowAdditionalInfo] = useState(false);
    const questions_data = JSON.parse(props.questions);
    const buttonText = props.params.buttontext[0];


    useEffect(() => {
        const dataQuestions = questions_data.map((question, idx) => {
            let additional_info = questions_data[idx].additional_info;
            let randomizer = 0.5;

            if (questions_data[idx].type === 'multiple-4')
                randomizer = 0.6;
            else if (questions_data[idx].type === 'multiple-3')
                randomizer = 0.7;
            else if (questions_data[idx].type === 'multiple-2')
                randomizer = 0.8;
            return ({
                ...question,
                additional_info,
                answers: [
                    question.correct_answer,
                    ...question.incorrect_answers,
                ].sort(() => Math.random() - randomizer)
            })
        })
        setQuestions(dataQuestions);
    }, []);

    const handleAnswer = (answer) => {

        if (!showAnswers) {  //prevent answers
            setSelectedAnswer(answer);
            setClassName('btn-choice-active');
            setShowAnswers(false)
            setShowAdditionalInfo(false);
            setTimeout(() => {
                setClassName((answer === questions[currentIndex].correct_answer) ? 'btn-choice-correct' : 'btn-choice-incorrect')
            }, 200);
            if (answer === questions[currentIndex].correct_answer) {
                setScore(score + 1);
                setShowAnswers(false);
                setShowAdditionalInfo(true);
            }
        }
        setShowAnswers(true);
        showCorrectAnswer(false);
    };

    const handleSeeCorrectAnswer = () => {
        showCorrectAnswer(true);
        setShowAdditionalInfo(true);
        setShowAnswerClassName(false);
    };


    const handleNextQuestion = () => {
        setShowAnswers(false);
        showCorrectAnswer(false);
        setClassName('btn-choice');
        setCurrentIndex(currentIndex + 1);
        setShowAdditionalInfo(false);
        setShowAnswerClassName(true);
    }

    const handlePlayAgain = () => {
        window.open(props.params.buttontext[0].url)
    }

    let msg = '';
    if (score === questions.length) {
        msg = buttonText.scoretop

    }
    else if ((score > 5) && (score < questions.length)) {
        msg = buttonText.scoremedium

    }
    else if (score <= 5) {
        msg = buttonText.scorelow
    }

    if (questions.length > 0) {
        return (
            <div className='quiz-container'>
                {currentIndex >= questions.length ? (
                    <div>
                        <div id='home' className='game-over'>
                            <h1 className='end-text'> {buttonText.end} {score} out of {questions.length}.</h1>
                            <h1 className='end-msg-result'> {msg}</h1>
                            <h1 className='end-msg'> {buttonText.endBtn} <a className="a" href={buttonText.url} >{buttonText.endBtn2}</a> </h1>

                            {/* </div> */}
                        </div>
                    </div>
                ) : (
                    <Questions
                        currentScore={score}
                        totalQuestions={questions.length}
                        currentIndex={currentIndex + 1}
                        data={questions[currentIndex]}
                        handleAnswer={handleAnswer}
                        handleNextQuestion={handleNextQuestion}
                        selectedAnswer={selectedAnswer}
                        className={className}
                        handleSeeCorrectAnswer={handleSeeCorrectAnswer}
                        showAnswers={showAnswers}
                        correctAnswer={correctAnswer}
                        handlePlayAgain={handlePlayAgain}
                        showAdditionalInfo={additionalInfo}
                        showAnswerClassName={showAnswerClassName}
                    />
                )
                }
            </div >
        )
    }
    else {
        return (
            <h2 className='loading' > loading! ...</h2>
        );
    }

} //function

export default Quiz;
